import styled from 'styled-components';

import { ScrollableContainer } from '@web/components/ScrollableContainer/ScrollableContainer';

export const Wrapper = styled(ScrollableContainer)`
  color: ${({ theme }) => theme.colors.gray};
  font: normal normal 12px/20px ${({ theme }) => theme.fonts.fontFamily};
  height: 100%;
  padding-top: 20px;
  min-width: max-content;
  width: 100%;
`;

export const Header = styled.h3`
  all: unset;
  border-bottom: 1px solid ${({ theme }) => theme.colors.separatorOnWhite};
  display: block;
  font-weight: 700;
  padding-bottom: 5px;
`;

export const MemberMenu = styled.div`
  background: white;
  border-radius: 4px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.08);
  left: 4px;
  position: absolute;
  padding: 10px;
  top: 100%;
  width: max-content;
  z-index: 1;
`;

export const MemberMenuItem = styled.button`
  background: transparent;
  border: 0;
  color: ${({ theme }) => theme.colors.gray};
  cursor: pointer;
  display: block;
  padding: 6px 10px;

  &:hover {
    background: rgba(0, 128, 255, 0.08);
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: none;
  }
`;

export const MemberButton = styled.label`
  background: transparent;
  border: 0;
  color: ${({ theme }) => theme.colors.gray};
  cursor: pointer;
  font-weight: 400;
  margin: 0 0 0 2px;
  padding: 0;
  transition: color 0.125s ease;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export const Member = styled.div`
  margin-top: 10px;
  position: relative;

  & ${MemberMenu} {
    display: none;
  }

  &:focus-within ${MemberMenu} {
    display: block;
  }

  &:focus-within ${MemberButton} {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export const MemberLink = styled.button`
  background: transparent;
  border: 0;
  color: ${({ theme }) => theme.colors.gray};
  cursor: pointer;
  display: inline-block;
  margin: 10px 0 0 2px;
  padding: 0;
  transition: color 0.125s ease;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: none;
  }
`;

type GroupButtonProps = {
  isActive: boolean;
};
export const GroupButton = styled(MemberButton)<GroupButtonProps>`
  margin-top: 10px;

  &::before {
    content: '';
    display: inline-block;
    border-color: transparent transparent transparent ${({ theme }) => theme.colors.iconGray};
    border-style: solid;
    border-width: 4px 0 4px 4px;
    font-size: 10px;
    height: 0;
    margin-right: 5px;
    transform: rotate(${({ isActive }) => (isActive ? '90deg' : '0deg')});
    transition:
      border-color 0.125s ease,
      transform 0.125s ease;
    width: 0;
  }

  &:hover::before {
    border-left-color: ${({ theme }) => theme.colors.primary};
  }
`;

export const Group = styled.div`
  padding-left: 10px;
`;
